import { Helmet } from 'react-helmet-async'

/**
 * Подключение счётчиков аналитики через Helmet.
 *
 * ID берутся из env-переменных Cloudflare Pages:
 *   - VITE_YM_ID         (Яндекс.Метрика, числовой)
 *   - VITE_GA4_ID        (Google Analytics 4, формат "G-XXXXXXXXXX")
 *   - VITE_CLARITY_ID    (Microsoft Clarity, формат "abcdefghij")
 *
 * Если переменная не задана — соответствующий счётчик не подключается.
 * Скрипты НЕ грузятся в dev (import.meta.env.DEV) — чтобы не палить трафик
 * с локальной разработки в production-аналитику.
 */
export function Analytics() {
  if (import.meta.env.DEV) return null

  const ymId = import.meta.env.VITE_YM_ID
  const gaId = import.meta.env.VITE_GA4_ID
  const clarityId = import.meta.env.VITE_CLARITY_ID

  return (
    <Helmet>
      {ymId && (
        <script type="text/javascript">{`
          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
          (window, document, "script", "https://mc.yandex.ru/metrika/tag.js?id=${ymId}", "ym");
          ym(${JSON.stringify(Number(ymId))}, "init", {
            ssr: true,
            webvisor: true,
            clickmap: true,
            ecommerce: "dataLayer",
            referrer: document.referrer,
            url: location.href,
            accurateTrackBounce: true,
            trackLinks: true
          });
        `}</script>
      )}
      {ymId && (
        <noscript>{`<div><img src="https://mc.yandex.ru/watch/${ymId}" style="position:absolute; left:-9999px;" alt="" /></div>`}</noscript>
      )}

      {gaId && (
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}></script>
      )}
      {gaId && (
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', ${JSON.stringify(gaId)}, { anonymize_ip: true });
        `}</script>
      )}

      {clarityId && (
        <script type="text/javascript">{`
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", ${JSON.stringify(clarityId)});
        `}</script>
      )}
    </Helmet>
  )
}
